<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">投屏结果</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search"></div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <h2 style="text-align: center">
          <div v-html="voteInfo.VoteName"></div>
        </h2>
        <div v-for="(group, index) in groupRankingList" :key="index">
          <h3 style="text-align: center">{{ group.GroupName }}</h3>
          <el-table
            :data="group.ScreenVoteGroupRankingList"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="RankNum"
              label="名次"
              width="50"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ProjectSort"
              label="原序号"
              width="60"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ProjectName"
              label="项目"
              width="260"
              header-align="center"
            >
            </el-table-column>
            <el-table-column
              prop="ProjectRemark"
              label="单位名称"
              header-align="center"
            >
            </el-table-column>
            <el-table-column label="详细信息" header-align="center">
              <template slot-scope="scope">
                <!-- <div v-html="scope.row.ProjectRemark1"></div> -->
                <el-popover placement="right" width="450" trigger="click">
                  <div
                    v-html="scope.row.ProjectRemark1"
                    style="overflow: auto; max-height: 450px"
                  ></div>
                  <div
                    v-html="scope.row.ProjectRemark1"
                    style="max-height: 60px; overflow: hidden"
                    slot="reference"
                  ></div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="得分"
              width="120"
              header-align="center"
              align="right"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.ProjectTotalScore">
                  {{ scope.row.ProjectTotalScoreText }}
                </span>
                <span v-if="!scope.row.ProjectTotalScore"> 未打分 </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
import screenApi from '../../../../api/mobileVote/screen' // screen投屏投票接口
export default {
  data () {
    return {
      groupRankingList: [],
      voteInfo: {}
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    refresh: function () {
      this.getGroupRankingList()
    },
    getGroupRankingList: function () {
      const openLoading = this.openLoading('', '.main_body')
      screenApi.getGroupRankingList({
        voteId: this.$route.params.vid
      }).then(data => {
        this.groupRankingList = data
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getVoteInfo: function () {
      voteManageApi.getVoteDetail({
        voteId: this.$route.params.vid
      }).then(data => {
        this.voteInfo = data
      }).catch(err => {
        return err
      })
    },
    exportData: function () {
      const _this = this
      _this.openLoading()
      voteManageApi.getVoteDetail({
        voteId: _this.$route.params.vid
      }).then(voteInfo => {
        screenApi.exportVoteScreenResult({
          VoteId: _this.$route.params.vid
        }).then(data => {
          if (!data) {
            return
          }
          let fileName = '投屏投票'
          fileName = voteInfo.VoteName
          const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

          const elink = document.createElement('a')
          // 设置下载文件名
          elink.setAttribute('download', fileName + '.xls')
          elink.style.display = 'none'
          elink.href = fileUrl
          document.body.appendChild(elink)
          elink.click()

          document.body.removeChild(elink) // 下载完成移除元素
          window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      }).catch(err1 => {
        _this.openLoading().close()
        return err1
      })
    }
  },
  created () {
    this.getGroupRankingList()
    this.getVoteInfo()
  }
}
</script>
<style lang="less">
</style>
